module.exports = __webpack_public_path__ + "static/img/avatar.d44e506.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/faces/avatar.jpg
// module id = 587
// module chunks = 31